
$(function () {
    $('#textboxGiftCardPriceX').on('change keyup', function () {

        const $self = $(this);

        setSelectedValueSelector($self.val());

        const $dropdown = $('#dropdownGiftCardPriceX');

        if ($dropdown.find(`option[value="${$self.val()}"]`).length > 0) {
            $dropdown.val($self.val());
        } else {
            $dropdown.val('');
        }
        ValidateQuantityAmount();
    });

    $('#textboxGiftCardPriceX, [name="Quantity"]').on('keypress', function (e) {
        // Prevent input of anything non-numeric
        return e.metaKey ||  // allow cmd/ctrl
            e.which <= 0 ||  // allow arrow keys
            e.which == 8 ||  // allow delete key
            e.which == 46 || // allow dot key
            /[0-9]/.test(String.fromCharCode(e.which)); // allow numbers
    });

    $('#dropdownGiftCardPriceX').on('change', function () {

        const $self = $(this);

        $('#textboxGiftCardPriceX').val($self.val());
        setSelectedValueSelector($self.val());
        ValidateQuantityAmount();
        $('#textboxGiftCardPriceX').valid();

    });

    $('#valueSelectorsGiftCardPriceX button').on('click', function () {


        const $self = $(this);

        $('#textboxGiftCardPriceX').val($self.data('value'));
        setSelectedValueSelector($self.data('value'));
        ValidateQuantityAmount();
        $('#textboxGiftCardPriceX').valid();
    });

    $('#Quantity').on('change keyup', function () {
        if ($('#Quantity').val() === undefined) { }
        else {
            ValidateQuantityAmount();
        }
    });

    ValidateQuantityAmount = function () {
        if (typeof g_maxorderValue === 'undefined') {
            return;
        }

        var selectedAmount = parseFloat($('#textboxGiftCardPriceX').val());
        var selectedQuantity = parseInt($('#Quantity').val());

        var maxOrderValue = parseFloat(g_maxorderValue);
        var maxQuantity = parseInt(g_maxQuantity);

        var isInvalid = false;
        var errorMessage = '';

        if (!isNaN(maxQuantity) && selectedQuantity > maxQuantity) {
            isInvalid = true;
            errorMessage = g_quantityError_ExceedsMax;
        } else if ((selectedAmount * selectedQuantity) > maxOrderValue) {
            isInvalid = true;
            errorMessage = g_quantityError_TooMany;
        }

        if (isInvalid) {
            $('#Quantity').removeClass('is-valid');
            $('#Quantity').addClass('is-invalid');
            $('#Quantity').attr('aria-invalid', true);

            var validationSpan = $('.quantity-container span.field-validation-valid');
            validationSpan.removeClass('field-validation-valid');
            validationSpan.addClass('field-validation-error');
            var errorSpan = '<span id=\"Quantity-error\">' + errorMessage + '</span>';
            validationSpan.append(errorSpan);
        } else {
            $('#Quantity').removeClass('is-invalid');
            $('#Quantity').addClass('is-valid');
            var validationErrorSpan = $('.quantity-container span.field-validation-error');
            validationErrorSpan.text('');
            validationErrorSpan.removeClass('field-validation-error');
            validationErrorSpan.addClass('field-validation-valid');
        }
    };

    setSelectedValueSelector = function (value) {
        $('#valueSelectorsGiftCardPriceX button').removeClass('selected');
        $(`#valueSelectorsGiftCardPriceX button[data-value="${value}"]`).addClass('selected');

        if ($('#valueSelectorsGiftCardPriceX button.selected').length) {
            $('#valueSelectorsGiftCardPriceX').addClass('has-selected');
        } else {
            $('#valueSelectorsGiftCardPriceX').removeClass('has-selected');
        }
    };
});
